import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, type Type } from '@angular/core';

@Component({
  selector: 'tellent-assistant-client-tool-render-part',
  imports: [NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (component(); as cmp) {
      <ng-container *ngComponentOutlet="cmp; inputs: outletInputs()" />
    }
  `,
})
export class ClientToolRenderPartComponent {
  protected readonly outletInputs = computed<Record<string, unknown>>(() => {
    const a = this.args();
    return a === undefined || a === null ? {} : { args: a };
  });

  public readonly component = input.required<Type<unknown> | undefined>();
  public readonly args = input<unknown>();
}
